// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb___ND4t","inactive":"styles_inactive__He8gw"};